import * as vp from 'vopay';
import { FunctionComponent, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useApprovalWorkflow } from '../../../providers/ApprovalWorkflow.provider';
import useFetchUserRoles from '../../../hooks/useApi/useFetchUserRoles';
import useFetchWorkflows from '../../../hooks/useApi/useFetchWorkflows';
import styles from './ApprovalSettingsContainer.module.scss';
import { useBranding } from '../../../providers/Branding.provider';
import { useTranslation } from 'react-i18next';

const { Box, Title, DetailsCard, Button, SubTitle, Icon } = vp;
type FC = FunctionComponent;
const ApprovalSettingsContainer: FC = () => {
  const { response: userRolesResponse, fetchUserRoles } = useFetchUserRoles();
  const [workflowsResponse, fetchWorkflows] = useFetchWorkflows({});
  const [fetchAdmin, setFetchAdmin] = useState(true);
  const { hasInvalidWorkflows } = useApprovalWorkflow();
  const { primaryColor } = useBranding();
  const history = useHistory();
  const { t } = useTranslation('translations', { keyPrefix: 'TransactionApproval.Configuration' });

  useEffect(() => {
    fetchUserRoles({
      Role: 'super admin',
    });
    fetchWorkflows({});
  }, []);
  useEffect(() => {
    if (userRolesResponse) {
      if (fetchAdmin) {
        fetchUserRoles({
          Role: 'approver',
        });
        setFetchAdmin(false);
      } else {
      }
    }
  }, [userRolesResponse]);
  return (
    <div>
      <Box mb="md" jc="sb">
        <Title title={t('title')} />
      </Box>
      <Box flx="col">
        <Box pb="md" width="100%">
          <DetailsCard
            width="100%"
            content={
              <Box jc="sb" ai="center" width="100%">
                <SubTitle subTitle={t('Cards.Roles.title')} variant="small" />
                <Button
                  label={t('Cards.Roles.button')}
                  color="primary"
                  height="36px"
                  id="manage-roles"
                  onClick={() => {
                    history.push('/transaction-approval/configuration/roles');
                  }}
                />
              </Box>
            }
          />
        </Box>
        <Box pb="md" width="100%">
          <DetailsCard
            width="100%"
            content={
              <Box jc="sb" ai="center" width="100%">
                <SubTitle
                  subTitle={
                    <Box flx="row" gapSize="7.5px" ai="center" jc="fs">
                      <span>{t('Cards.Workflows.title')}</span>
                      {hasInvalidWorkflows && (
                        <div className={styles.notificationIconLarge}>
                          <Icon
                            icon="exclamation"
                            width="4px"
                            height="10px"
                            color={vp.getLuminance(primaryColor) > 0.5 ? 'primary-dark' : 'primary-light'}
                            position="center"
                          />
                        </div>
                      )}
                    </Box>
                  }
                  variant="small"
                />
                <Button
                  label={t('Cards.Workflows.title')}
                  color="primary"
                  height="36px"
                  id="manage-workflows"
                  onClick={() => {
                    if (Object.keys(workflowsResponse?.Workflows || {}).length > 0) {
                      history.push('/transaction-approval/configuration/workflows');
                    } else {
                      history.push('/transaction-approval/configuration/workflows/add');
                    }
                  }}
                />
              </Box>
            }
          />
        </Box>
      </Box>
    </div>
  );
};
export default ApprovalSettingsContainer;
